import { typedQueryClient, useTypedMutation } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Snooze } from "models";

export const useAppendSnoozeMutation = () =>
  useTypedMutation<Snooze, number>({
    mutationFn: async snooze => (await ApiInstance.post("/snoozes/append", snooze)).data.id,
    onSuccess: (snooze, id) => {
      const snoozeItems = typedQueryClient.getQueryData(CarDetailsQueryKeys.snoozeItems);
      if (!snoozeItems || snoozeItems.some(snoozeItem => snoozeItem.id === id)) return;

      const appendedSnooze = { ...snooze, id };

      for (const snoozeItem of snoozeItems) {
        if (snoozeItem.appointment_id === snooze.appointment_id && !appendedSnooze.appointment) appendedSnooze.appointment = snoozeItem.appointment;
        if (snoozeItem.intervention_id === snooze.intervention_id && !appendedSnooze.intervention) appendedSnooze.intervention = snoozeItem.intervention;
        if (snoozeItem.user_id === snooze.user_id && !appendedSnooze.user) appendedSnooze.user = snoozeItem.user;
      }

      typedQueryClient.setQueryData(CarDetailsQueryKeys.snoozeItems, [...snoozeItems, appendedSnooze]);
    }
  });
